import React from "react";

const Add: React.FC = () => (
  <path
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="32"
    d="M256 112v288M400 256H112"
  />
);

export default Add;
